import { render, staticRenderFns } from "./SSO.vue?vue&type=template&id=22fe6ab8&"
import script from "./SSO.vue?vue&type=script&lang=js&"
export * from "./SSO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports